import { IUser } from '../interfaces';

export class UserHelper {
  public static getFullName(user: IUser): string {
    return user.middleName
      ? `${user.firstName} ${user.middleName} ${user.lastName}`
      : `${user.firstName} ${user.lastName}`;
  }
}
